import { Component, ElementRef, Injector, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { Firearm, FIREARM_TYPE } from 'assets-model';
import { AssetService, FirearmService, MechanicalAspectService, RefCodeStorage } from 'assets-service';
import { ASSET_SEARCH_RESULT_DATA_COLUMNS } from '../../asset/search/asset-search.component';
import { FIREARM_SEARCH_BASIC_COLUMNS, FirearmSearchComponent } from '../search/firearm-search.component';

export const FIREARM_DATA_UPLOAD_COLUMNS = ['selectedForImport', ...ASSET_SEARCH_RESULT_DATA_COLUMNS, 'tags', ...FIREARM_SEARCH_BASIC_COLUMNS, 'assignedRanger', 'wildlifeManager']//, ...ASSET_SEARCH_ALL_ASPECT_COLUMNS];

export type ImportRow = {
  selectedForImport: boolean;
}

export type FirearmImportRow = Firearm & ImportRow;

@Component({
  selector: 'app-firearm-data-upload',
  templateUrl: './firearm-data-upload.component.html',
  styleUrls: ['./firearm-data-upload.component.scss']
})
export class FirearmDataUploadComponent extends FirearmSearchComponent {

  importRows: FirearmImportRow[];

  get rowsLoaded() {
    return this.importRows != null && this.importRows.length > 0;
  }

  @ViewChild("fileInput") fileInputRef: ElementRef;
  selectedFile: File = null;

  error: any;

  displayedColumns: string[] = [...FIREARM_DATA_UPLOAD_COLUMNS];
  disabledColumns: string[] = [];

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected firearmService: FirearmService,
    protected assetService: AssetService,
    protected mechanicalAspectService: MechanicalAspectService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(route, router, userStorage, dialog, firearmService, assetService, refCodeStorage, fb, formStorage, injector);
    this.autoSearch = false;
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    if (this.sort) {
      this.sort.disabled = true;
    }
  }

  //disable actual search functionality
  createServiceArguments() {
    return {}
  }

  uploadFile() {
    if (this.selectedFile != null) {
      this.firearmService.getFirearmsFromFile(this.selectedFile).subscribe(
        data => {
          this.importRows = <any>data.items;
          this.importRows.forEach(row => row.selectedForImport = true);
          this.error = null;
        },
        error => {
          this.importRows = [];
          this.error = error.error;
          if (!this.error.friendlyMessage) {
            this.error = {
              friendlyMessage: "Unkown error, see dialog for details.",
              title: "Unknown"
            }
            throw error;
          }
        }
      )
    }
  }

  importEnabled() {
    return this.importRows != null && this.importRows.filter(r => r.selectedForImport).length > 0;
  }

  import() {
    var selectedFirearms = this.importRows.filter(r => r.selectedForImport);
    this.firearmService.importAll(selectedFirearms).subscribe(
      data => {
        this.importRows = [];
        this.error = null;
        this.openSimpleConfirmationDialog("All firearm assets imported successfully. Do you want to view these firearm assets in the search screen?", "Import Successful", "Yes", "No").afterClosed().subscribe(
          result => {
            if (result) {
              this.router.navigate(FIREARM_TYPE.searchRouteBase);
            }
          }
        );
      },
    );
  }

  clearFileInput() {
    if (this.fileInputRef) {
      this.fileInputRef.nativeElement.value = null;
    }
  }

  fileInputChanged(files: FileList) {
    this.selectedFile = files[0]
  }

  toggleSelected(row: FirearmImportRow) {
    row.selectedForImport = !row.selectedForImport;
  }

  getImportDataField(row: FirearmImportRow, field: string) {
    return row.importDataMap[field];
  }

  cellClass(element: FirearmImportRow, fieldName: string): any {
    var cls = super.cellClass(element, fieldName) || {};
    cls['no-import'] = element.selectedForImport == false;
    return cls;
  }

  rowClass(row: FirearmImportRow) {
    var cls = {
      'no-import': row.selectedForImport == false
    }
    return cls;
  }

  selectAll() {
    this.importRows.forEach(r => r.selectedForImport = true);
  }

  deselectAll() {
    this.importRows.forEach(r => r.selectedForImport = false);
  }


}
